var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"hidden-sm-and-down",attrs:{"href":_vm.link,"target":"_new","title":_vm.title},on:{"click":function($event){_vm.$emit('click')}}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("print")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }